import { Component, Vue, Watch } from 'vue-property-decorator';
import Form from '../utils/Form';
// @ts-ignore
import { VueMaskDirective } from 'v-mask';
import { debounce, inArray } from '../utils/miscellanea';
import { HTTP } from '../utils/fetch';

Vue.directive('mask', VueMaskDirective);

@Component
export default class ContactForm<T extends object> extends Vue {
  form!: Form<T>;
  isFormReady = false;
  protected requiredFields = <Array<string>>[];
  protected isLoading = false;
  protected _http!: HTTP;
  protected _token!: string;
  private debCheckForm = debounce(() => this.checkForm(true), 1000);

  mounted(): void {
    this._http = HTTP.instance();
    this._token = (<HTMLElement>this.$refs.token)?.innerText || '';
  }

  @Watch('form', { deep: true })
  onFormChange() {
    this.debCheckForm();
  }

  @Watch('isLoading')
  onIsLoadingChange(val: boolean) {
    if (val) {
      document.body.classList.add('site--loading');
    } else {
      document.body.classList.remove('site--loading');
    }
  }

  protected preCheckForm(onlyClearErrors = false): number {
    return 0;
  }

  protected checkFormField(key: string, onlyClearErrors = false): number {
    if (!this.form.data[<keyof T>key]) {
      if (!onlyClearErrors) {
        this.form.errors.add(key, 'empty field');
      }
      return 1;
    } else {
      this.form.errors.clear(key);
      return 0;
    }
  }

  protected checkForm(onlyClearErrors = false): void {
    let errorsCounter = this.preCheckForm(onlyClearErrors);

    for (const key in this.form.data) {
      if (!inArray(key, this.requiredFields)) {
        continue;
      }
      errorsCounter += this.checkFormField(key, onlyClearErrors);
    }

    this.isFormReady = errorsCounter == 0;
  }
}
